/**
 * Javascript imports
 * 
 */

import LazyLoad from "vanilla-lazyload";
import jQuery from "jquery";
import Popper from 'popper.js';
import {
    collapse,
    button,
    dropdown,
    modal
} from 'bootstrap';
import {
    dataJs,
    dataAnchor,
    getHash
} from './theme-utils/data-selector';
import smoothscroll from 'smoothscroll-polyfill';


// Make jQuery globally available
// Should work in webpack as well.
window.$ = window.jQuery = jQuery;

// Setup

document.addEventListener('readystatechange', event => {
    if (event.target.readyState === 'interactive') {
        console.log('interactive');
        smoothscroll.polyfill();
 
    }
    else if (event.target.readyState === 'complete') {
        console.log('complete');
        checkForScrolling();
        document.body.classList.add('body--loaded');
        var lazyLoadInstance = new LazyLoad({
            elements_selector: "[loading=lazy]",
            threshold: 0,
            use_native: false
        });

    }
  });


window.onhashchange = function () {
    checkForScrolling();
};


// this function handles scrolling to data-anchors
function checkForScrolling() {
    // first get your element by attribute selector
    var elem = document.querySelector('[data-anchor="' + getHash() + '"]');
    // check if element exists
    if (elem) {
        window.scroll({
            // set position but take navbar height into calculation ( 60px )
            top: (elem.getBoundingClientRect().top - 42) + window.pageYOffset,
            // top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
}

